import {
  DevToolsLayout,
  InfoContent,
  ScheduledTasksContent,
} from '@backstage/plugin-devtools';
import { UnprocessedEntitiesContent } from '@backstage/plugin-catalog-unprocessed-entities';
import { EntityValidationContent } from '@backstage-community/plugin-entity-validation';
import Typography from '@material-ui/core/Typography';

const CustomDevToolsPage = () => {
  return (
    <DevToolsLayout>
      <DevToolsLayout.Route path="info" title="Info">
        <InfoContent />
      </DevToolsLayout.Route>
      <DevToolsLayout.Route path="scheduled-tasks" title="Scheduled Tasks">
        <ScheduledTasksContent />
      </DevToolsLayout.Route>
      <DevToolsLayout.Route
        path="unprocessed-entities"
        title="Unprocessed Entities"
      >
        <UnprocessedEntitiesContent />
      </DevToolsLayout.Route>
      <DevToolsLayout.Route path="entity-validation" title="Entity Validation">
        <EntityValidationContent
          contentHead={<Typography variant="h6">Entity Validation</Typography>}
        />
      </DevToolsLayout.Route>
    </DevToolsLayout>
  );
};

export const customDevToolsPage = <CustomDevToolsPage />;
